export default __webpack_public_path__ + "static/media/logooo.36d48121.png";